<!--
 * @Author: soji
 * @Description: 描述
 * @Date: 2024-07-09 16:54:10
-->
<template>
  <div class="store-menu">
    <div class="store-wrap">
      <div class="store-notice" v-if="announcement">
        <div class="store-notice-title">
          <marquee>
            <span>
              {{announcement}}
            </span>
          </marquee>
        </div>
        <div class="store-notice-hover am-padding-horizontal-xs">
          <div class="store-notice-title ">门店公告</div>
          <div class="store-notice-content ">
            <p>{{announcement}}</p>
          </div>
        </div>
      </div>
      <!--餐单展示-->
      <Card :bordered="false" dis-hover :headerStyle="{background: '#d4d5d5'}">
        <h2 slot="title">
          <!--搜索餐品：-->
          <cc-input :value="keywords"
                    :styleObj="{maxWidth:'300px',minWidth:'100px',width:'100%'}"
                    placeholder="请输入餐品名称"
                    title="搜索餐品："
                    @select="checkSearchProduct"
                    @input="searchProduct"
                    @blur="clearSearchData"
                    :inputlistdata="searchFoodData"
                    :showinputlist="true"
                    class="store-search-wrap"
                    v-show="canSearch"
          >
            <template slot="itemText" slot-scope="props">
              <span v-if="!props.item.typeName">{{props.item.productName}}</span>
              <span v-else>[{{props.item.typeName}}] {{props.item.productName}}</span>
            </template>
          </cc-input>
        </h2>
        <!--分类-->
        <div class="store-category">
          <ul class="category-list  scroll">
            <li v-for="(item, index) in category" :key="index" @click="checkCategory(item)" class="category-item"
                :class="{'category-item-active': (!item.uid&&smallUid === categoryUid)||(item.uid &&(item.uid === categoryUid || item.uid === smallUid)) }">
              <div class="category-text am-text-center am-text-truncate" :title="item.name | trim">
                {{item.name | trim}}
              </div>
            </li>
          </ul>
        </div>
        <!--产品列表-->
        <div class="store-product am-margin-vertical-sm scroll ">
          <div class="product-list show" :class="{disabled: !isAddCart}">
            <Poptip trigger="hover" placement="top" v-for="(item, index) in productList" :key="index" padding="3px 5px">
              <div slot="content" style="color:#000">
                温馨提示：该餐品已选{{ item.num ||0 }}份
              </div>
              <div class="product-item" :class="{disabled: item.disabled}" @click="addProduct(item)">
                <div class="product-trait am-text-truncate">{{item | productTrait}}</div>
                <div class="product-type am-text-right am-text-truncate">{{item.typeText}}</div>
                <div class="product-text " :title="item.name | trim ">
                  {{item.name | trim }}
                </div>
                <div class="product-close am-text-center" v-if="item.disabled">{{item.warnText}}</div>
                <div class="product-inventory am-text-center" v-else-if="item.maxNum > 0">
                  剩余{{item.stockNum-item.num}}份
                </div>
              </div>
            </Poptip>
          </div>
        </div>
      </Card>
    </div>
    <cc-loading-box class="loading-box" :isLoading="loading"></cc-loading-box>
  </div>
</template>

<script>
  import {mapState} from 'vuex'
  import {deepClone, each, throttle} from '@/utils/assist'
  import {isDisabled, isType, isChange, action} from '@/utils/productAction'
  import Card from '@/components/Card/index'
  import Poptip from '@/components/Poptip/index'
  import CcInput from '@/components/Cc-Input'
  import LoadingBox from '@/components/Cc-Loading'

  export default {
    name: 'storeMenu',
    inject: ['productsUseNum'],
    props: {
      vipVolumeKey: {
        type: Number // 贵宾卷ID
      },
      isVipVolume: {
        type: Boolean // 是否贵宾卷
      },
      isAddCart: { // 是否可以添进购物车
        type:Boolean
      }
    },
    created() {
      this.$on('order-update', (o) => {
        this.init(o)
      });
      this.$on('cart-update', () => {
        this.getProductList();
      })
    },
    filters: {
      productTrait(item) {
        let {isSpecialty, isNew, isSpicy, isSideDish} = item,
          arr = [isSpecialty, isNew, isSpicy, isSideDish],
          key = ['招牌', '新品', '辣', '配菜'],
          max = arr.length - 1,
          list = [],
          text = '';
        for (let i = 0; i < max; i++) {
          if (arr[i]) {
            list.push(key[i])
          }
        }
        text = list.join(',');
        return text
      },
      trim(value) {
        return value && value.replace(/^\s+|\s+$/gm, '');
      }
    },
    data() {
      return {
        productList: [],
        keywords: '', // 搜索餐品关键字
        searchFoodData: [], // 搜索列表
        menuId: null, // 餐单ID
        canSearch: false, // 是否能搜索
        orderProduct: [], // 订单餐品
        loading: false, // 餐单加载
      }
    },
    mounted() {
    },
    computed: {
      allProduct() {
        // 对所有产品进行是否禁用,类型，改变
        let products = deepClone(this.menu.products),
          o = {};
        each(products, (product) => {
          isDisabled(product, 1); // 忘记
          isType(product);
          isChange(product);
          o[product.uid] = product
        });
        return o
      },
      category() {
        // orderProduct上次已购餐品
        let list = [],
          menu = this.menu,
          orderProduct = this.orderProduct,
          bigCategory = menu.bigs,
          smallCategory = menu.smalls;
        if (smallCategory && bigCategory) {
          if (smallCategory.length > 0) list.push(...smallCategory);
          else list.push(...bigCategory)
        }
        if (orderProduct.length > 0) {
          list.unshift({
            name: '上次已购餐品',
            uid: 0,
            categoryUid: 0
          })
        }
        return list
      },
      ...mapState({
        storeId: state => state.booking.user.storeId, // 门店
        brandId: state => state.booking.user.brandInfo.brandId,// 品牌
        orderType: state => state.booking.user.sendType, // 业务类型
        reserveDate: state => state.booking.user.reserveDate, // 当前时间
        cart: state => state.booking.cart, // 购物车
        user: state => state.booking.user.data, // 用户信息
        categoryUid: state => state.booking.menu.activeBig, //大分类ID
        smallUid: state => state.booking.menu.activeSmall, // 小分类ID
        announcement: state => state.booking.store.data.ccAnnouncement,
        menu: state => state.booking.menu.data, // 餐单信息
        orderData: state => state.booking.preferential.orderData,
      })
    },
    methods: {
      getProductList () {
        // 返回当前选中分类对应的产品列表，以及监听购物车的产品数量变化，给当前显示的产品修改数量
        let products = this.menu._products,
          productsUseNum = this.productsUseNum,
          allProduct = this.allProduct,
          categoryUid = this.categoryUid || this.smallUid,
          list = [];
        if (!categoryUid) {
          products = this.orderProduct
        }
        each(products, (value) => {
          let uid = value.uid || value.pid,
            num = productsUseNum[uid]|| 0;
          value = allProduct[uid] || value;
          value.num = num;
          list.push(value)
        });
        this.productList = list;
      },
      handleAction: action,
      init({isStore, isAppointmentDate, isOrderType, isAmend} ) {
        // 餐单初始化 @params isStore门店更换 isOrderType 业务类型更换 isAppointmentDate 预约时间更换
        if (isStore) {
          this.$store.dispatch('booking/cart/clear')
        }
        this.loading = true;
        this.canSearch = false;
        if (isAppointmentDate) {
          this.getProductMenu().finally(() => this.loading = false).then(()=> {
            this.compareCartAndProducts();
          })
        } else if (!isAmend) {
          this.getProductMenu().then(this.getCcUserLastFinishOrder).finally(() => this.loading = false).then(() => {
            this.compareCartAndProducts();
          })
        } else {
          let category = this.category;
          category.length&&this.checkCategory(category[0]);
          this.menuId = this.menu.menuId;
          this.canSearch = true;
          this.loading = false;
        }
      },
      getProductMenu() {
        //获取餐单
        let {orderType, reserveDate, storeId} = this;
        return this.server.get({
          name: "getProductMenu",
          data: {
            storeId,
            sendType: orderType,
            reserveDate: orderType !== 1 ? reserveDate : null,
            isCCChangeOrder: true,
            fromType: this.orderData.fromType,

          }
        }).then(res => {
          if (res.status === 1) {
            this.menuId = res.data.menuId;
            this.canSearch = true;
            this.$store.dispatch('booking/menu/init', {...res, removeEmptyCat: true});
            this.getProductList();
            return
          }
          this.$Modal.confirm({
            title: '提示',
            content: res.msg,
            okText: '重选门店',
            cancelText: '取消',
            onOk: () => {
              this.$router.push({name: 'customer'})
            }
          });
          this.$store.commit('booking/menu/clear');
          return new Promise(() => {
          })
        })
      },
      getCcUserLastFinishOrder() {
        //获取用户最近一次下单的产品, 对当前餐品不属于当前餐单的或禁用的进行剔除
        let {user, orderType, brandId, allProduct} = this,
          {uid} = user;
        return this.server
          .get({
            name: "getCcUserLastFinishOrder",
            data: {
              brandId,
              userId: uid,
              orderType
            }
          })
          .then(res => {
            let list = [], o = allProduct, data = res.data;
            if (data && data.orderProductList) {
              let products = data.orderProductList;
              each(products, (value) => {
                let item = o[value.pid];
                if (item && !item.disabled) {
                  list.push(item)
                }
              })
            }
            this.orderProduct = list
          })
      },
      checkSearchProduct(product) {
        // 选择搜索的餐品
        let products = this.allProduct,
          uid = product.pid;
        if (product.canEdit) return;
        if (uid && (product = products[uid])) {
          if (product.disabled) return this.$Modal.error({title: '提示', content: `${product.warnText}`});
          this.addProduct(product);
          this.clearSearchData();
        } else {
          this.$Modal.error({title: '提示', content: `在餐单中找不到该餐品，无法添加成功}`})
        }
      },
      throttle: throttle(),
      searchProduct(key) {
        // 搜索餐品
        let _this = this, { storeId } = _this;
        _this.searchFoodData = [{productName: '搜索中，请稍候..', canEdit: true}];
        this.throttle({
          callback(key) {
            key += '';
            if (key.trim()) {
              let {menuId} = _this;
              this.server.get({
                name: 'getSearchProduct',
                data: {
                  key,
                  menuId,
                  storeId
                }
              }).then((res) => {
                let data = [{productName: '查无该餐品，请重新输入！', canEdit: true}];
                if (res.data.length > 0) data = res.data;
                _this.searchFoodData = data
              })
            } else {
              _this.searchFoodData = []
            }
          },
          delay: 800,
          arg: [key]
        })
      },
      clearSearchData() {
        // 清除数据
        this.keywords = '';
        this.searchFoodData = [];
      },
      checkCategory(item) {
        //选择分类
        let activeSmall = 0,
          activeBig,
          {parentId, uid} = item;
        if (parentId) {
          activeBig = parentId;
          activeSmall = uid
        } else {
          activeBig = uid
        }
        this.$store.dispatch('booking/menu/update', {activeBig, activeSmall});
        this.$store.dispatch('booking/menu/filterProduct');
        this.getProductList();
      },
      addProduct(product) {
        //单品就直接添到购物车 套餐与特殊要求的统一处理 @param plu是单品的操作 addition是特殊要求 combo是套餐的
        let {cart, isVipVolume, vipVolumeKey, isAddCart} = this,
          _this = this,
          state = false,
          warnText = '',
          {_key, num, disabled, maxNum, name, uid} = product;
        each(cart.products, (product) => {
          if (product.uid === uid) _key = product._key;
        });
        product = cart.products[_key] || product;
        if (disabled) return;
        state = [
          function () {
          if (!isAddCart) {
            warnText = `当前处于修改订单状态,餐品不可以添加`;
            return true
          }
          },
          function () {
          if (maxNum && num >= maxNum) {
            warnText = `当前餐品${name}库存不足`;
            return true
          }
          },
          function () {
            // 吉野家定制贵宾卷
          if (isVipVolume&&product.uid === vipVolumeKey) {
            warnText = `请勿手动添加${product.name}`;
            return true
          }

        }
        ].some(function (fn) {
          let state = !!fn();
          if (state) {
            _this.$Modal.error({title: '提示', content: warnText})
          }
          return state
        });
        if (state) return;
        this.handleAction(product, {
          plu(product) {
            this.$store.dispatch('booking/cart/doPlus', {...product, num: 1})
          },
          addition() {
            this.$emit('initAdditional', {_key})
          },
          combo() {
            this.$emit('getProductGroup', product)
          },
          combination() {
            this.$emit('getProductCombination', product)
          }
        })
      },
      compareCartAndProducts() {
        //对购物车的产品进行比较，保留还在餐单上的餐品
        let {cart} = this,
          products = this.allProduct,
          pastDueProducts = [],
          keys = [],
          names = [];
        each(cart._products, (value) => {
          let uid = value.pid,
            product = products[uid];
          //isInServiceTime
          //对不存在或者状态禁用
          if (!product || product.disabled) {
            keys.push(product._key);
            names.push(product.name)
          }
          if (product&&!product.isInServiceTime) {
            pastDueProducts.push(product);
          }
        });
        if (pastDueProducts.length > 0 && names.length === pastDueProducts.length) {
          this.$Modal.confirm({
            title: '提示',
            content: `${names.join(',')}餐品不在供应时间，不可选购，确认将清除购物车`,
            okText: '确定',
            cancelText: '取消',
            onOk: () => {
              this.$store.dispatch('booking/cart/batchProcessingPro', keys)
            }
          });
          return
        }
        if (keys.length > 0) {
          this.$Modal.error({
            title: '提示',
            content: names.join(',') + '餐品,当前状态不可选购，请重新选择'
          });
          this.$store.dispatch('booking/cart/batchProcessingPro', keys)
        }
      }
    },
    components: {
      Card,
      Poptip,
      CcInput,
      ccLoadingBox: LoadingBox
    },
    destroyed() {
    }
  }
</script>

<style lang="less">

  @css-prefix: '';
  @store-prefix-cls: ~"@{css-prefix}store";
  .@{store-prefix-cls}-menu {
    position: relative;
    overflow: hidden;
    min-width: 150px;
    max-width: 730px;
    flex: auto;
    z-index: 1;
    .@{store-prefix-cls}-notice {
      padding: 4px 6px;
      position: relative;
      line-height: 1;
      &:hover .@{store-prefix-cls}-notice-hover {
        display: block;
      }
    }
    .@{store-prefix-cls}-notice-title {
      overflow: hidden;
      white-space: nowrap;
      position: relative;
    }
    .@{store-prefix-cls}-search-wrap {
      display: flex;
      flex-wrap: nowrap;
    }
    .@{store-prefix-cls}-notice-hover {
      display: none;
      position: absolute;
      left: 0;
      z-index: 2;
      border: 1px solid #dcdee2;
      background: #fff;
      top: 100%;
      right: 0;
      line-height: 1.8;
    }
    .@{store-prefix-cls}-notice-title {
      font-size: 16px;
      font-weight: bold;
      padding-top: 6px;
    }
    .@{store-prefix-cls}-wrap {
      /*min-width: 150px;*/
      /*max-width: 730px;*/
      /*flex: 1;*/
      /*width: 610px;*/
    }
    .@{store-prefix-cls}-product {
      height: 624px;
      overflow-x: hidden;
      overflow-y: auto;
      margin-left: -20px;
      padding-left: 20px;
    }
    .@{store-prefix-cls}-notice-content {
      min-height: 80px;
      padding: 10px 50% 10px 0;
    }
  }

  .category-list {
    display: flex;
    flex-wrap: wrap;
    .category-item {
      color: #fff;
      cursor: pointer;
      background-color: #3b5d8b;
      border: 2px solid #3b5d8b;
      width: 134px;
      margin: 5px 10px 5px 0;
      border-radius: 5px;
      padding: 10px;
      font-size: 12px;
      align-items: center;
      &.category-item-active {
        background-color: #fff;
        color: #3b5d8b;
      }
    }
  }

  .product-list {
    display: none;
    color: #fff;
    &.show {
      display: flex;
      flex-wrap: wrap;
    }
    &.disabled {
      .product-item {
        cursor: not-allowed;
      }
    }
    .product-item {
      cursor: pointer;
      overflow: hidden;
      position: relative;
      width: 134px;
      height: 114px;
      margin: 5px 10px 5px 0;
      color: #fff;
      border-radius: 5px;
      padding: 29px 10px;
      background: rgb(102, 50, 153);
      align-items: center;
      &.disabled {
        background: rgb(117, 132, 151);
        cursor: not-allowed;
        color: #fff;
      }
    }
    .product-item {
      .product-text {
        overflow: hidden;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        line-height: 20px;
        display: -webkit-box;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
        white-space: normal;
      }
      .product-type, .product-trait {
        position: absolute;
        padding: 0 5px;
        color: #f0eb8a;
        width: 50%;
      }
      .product-type {
        top: 0;
        right: 0;
      }
      .product-trait {
        position: absolute;
        top: 0;
        left: 0;
      }
      .product-inventory, .product-close {
        position: absolute;
        bottom: 0;
        padding: 3px 5px;
        left: 0;
        right: 0;
      }
      .product-close {
        background: rgb(108, 108, 108);
      }
      .product-inventory {
        background: rgba(0, 0, 0, .5)
      }
    }
  }
</style>



// WEBPACK FOOTER //
// components/pages/order/StoreMenu/StoreMenuNew.vue